// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// manageとexecute同じ内容記載のためmanageに統一
import { mapState, mapActions } from 'vuex';
import api from '../../../../../manage/src/common/api';
import config from '../../../../../manage/src/share/config';
import handler from '../../../../../manage/src/share/util/apiResultValidator';
import loading from '../../../../../manage/src/share/components/vue/ProcessingIcon';

export default {
  data() {
    return {
      user_name: '',
      password: '',
      newPassword: '',
      newPasswordConfirm: '',
      processing: false,
      previousName: ''
    };
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      userId: state => state.userProperty.userId,
      cachedPopUpMenuPrevious: state => state.cache.popUpMenuPreviousStores,
    }),

    isManadatoryFilled: {
      get: function () {
        if (this.newPassword === '' || this.newPasswordConfirm === '') {
          return false;
        }
        if (this.newPassword !== this.newPasswordConfirm) {
          return false;
        }
        return true;
      },
    },
  },

  // 遷移してきた画面のパラメータ情報を保持
  beforeRouteEnter(_, from, next) {
    next(vm => {
      // ポップアップメニュー内の画面以外の場合、 前画面情報をキャッシュに保持
      if (from.params && !config.POPUP_MENU_DISPLAY_NAME.includes(from.name)) {
        vm.cachePopUpMenuPreviousStores({ previousName: from.name, queryName: from.query, params: from.params });
      }
    });
  },

  methods: {
    ...mapActions('auth', ['logout', 'changePassword']),
    ...mapActions('cache', ['cachePopUpMenuPreviousStores']),

    executeChangePassword: function () {
      if (this.isManadatoryFilled) {
        this.didTapChangePasswordButton();
      }
    },

    // Function for handling the change password button action.
    didTapChangePasswordButton: async function () {
      if (this.processing) return;
      this.processing = true;
      const param = { new_password: this.newPassword };
      const response = await api.postCall(config.ADMIN, `/changePassword/` + this.userId, param);
      this.processing = false;

      // APIレスポンスの検証
      handler.validate(
        handler.validateTypes.all, response, this, null, async () => {
          // 成功した場合
          this.backToPrevious();
        },
        (result) => {
          // 失敗した場合
          if (result.behaviorType === handler.behaviorTypes.logout) {
            this.logout(this);
          } else {
            this.setDefaultFocus();
          }
        }, 'message.label_msg_password_changed_successfully');
    },

    backToPrevious: function () {
      // キャッシュから前画面情報取得
      const params = this.cachedPopUpMenuPrevious.params;
      if (params) {
        params.previousDisplayName = 'changePassword';
        this.$router.push({
          name: this.cachedPopUpMenuPrevious.previousName,
          params: params,
          query: this.cachedPopUpMenuPrevious.queryName
        });
      } else {
        this.$router.push({ name: this.cachedPopUpMenuPrevious.previousName, params: { previousDisplayName: 'changePassword' } });
      }
    },

    setDefaultFocus: function () {
      setTimeout(() => {
        const control = document.getElementById("id-new-password");
        if (window.location.href.includes('manage') && control) {
          control.focus();
        }
      }, 250);
    },
  },

  created() {
    // noop
  },
  mounted() {
    this.setDefaultFocus();
  }
};
